import { AnchorScrollTo } from '@studiometa/ui';
import { transition } from '@studiometa/js-toolkit/utils';

/**
 * BackToTop button
 */
export default class BackToTop extends AnchorScrollTo {
  static config = {
    name: 'BackToTop',
  };

  /**
   * Is active ?
   * @type {boolean}
   */
  isActive = false;

  /**
   * Scrolled
   * @param {Event} props
   */
  scrolled({ y }) {
    if ((y < window.innerHeight && !this.isActive) || (y > window.innerHeight && this.isActive)) {
      return;
    }
    if (y > window.innerHeight && !this.isActive) {
      this.isActive = true;
      transition(
        this.$el,
        {
          from: 'opacity-0 translate-y-full',
          active: 'transition duration-300 ease-out-quad',
          to: 'pointer-events-auto',
        },
        'keep',
      );
      return;
    }
    this.isActive = false;
    transition(
      this.$el,
      {
        from: 'pointer-events-auto',
        active: 'transition duration-300 ease-out-quad',
        to: 'opacity-0 translate-y-full',
      },
      'keep',
    );
  }
}
